import { render, staticRenderFns } from "./LembretePagamento.vue?vue&type=template&id=ab69cd04&"
import script from "./LembretePagamento.vue?vue&type=script&lang=js&"
export * from "./LembretePagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports